import script from "./CalendarScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarScreen.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__